import { useEffect, useRef, useState } from 'react';

const useIntersectionObserver = () => {
  const visibleRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        rootMargin: '0px',
        threshold: 1.0,
      },
    );
    if (visibleRef?.current) {
      intersectionObserver.observe(visibleRef.current);
    }
    return () => {
      intersectionObserver.disconnect();
    };
  }, [visibleRef]);

  return { isVisible, visibleRef };
};

export default useIntersectionObserver;
